import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CurrencyFranc = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 14H12V7C12 5.346 13.346 4 15 4H25C25.552 4 26 3.552 26 3C26 2.448 25.552 2 25 2H15C12.243 2 10 4.243 10 7V20H7C6.448 20 6 20.448 6 21C6 21.552 6.448 22 7 22H10V29C10 29.552 10.448 30 11 30C11.552 30 12 29.552 12 29V22H21C21.552 22 22 21.552 22 21C22 20.448 21.552 20 21 20H12V16H25C25.552 16 26 15.552 26 15C26 14.448 25.552 14 25 14Z" />
	</svg>
);

export default CurrencyFranc;
